module.exports = __webpack_public_path__ + "img/logo1.b5669eb4.png";